export default class Telemetry {
    constructor (
        route,
        startPoint,
        endPoint,
        routeBoundary,
        startUtc,
        endUtc,
        idlePoints,
        noGpsEvents,
        journeyStartGapPoints,
        journeyEndGapPoints,
        journeySpeedPoints,
        lengthMeters,
        lengthKm,
        id
    ) {
        this.route = route
        this.startPoint = startPoint
        this.endPoint = endPoint
        this.routeBoundary = routeBoundary
        this.startUtc = startUtc
        this.endUtc = endUtc
        this.idlePoints = idlePoints
        this.noGpsEvents = noGpsEvents
        this.journeyStartGapPoints = journeyStartGapPoints
        this.journeyEndGapPoints = journeyEndGapPoints
        this.journeySpeedPoints = journeySpeedPoints
        this.lengthMeters = lengthMeters
        this.lengthKm = lengthKm
        this.id = id
    }
}
